import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaLeadFilterModule } from '../filter';
import { LeadTableModule } from '../../../../crm/lead/view/table';

import { CampanhaLeadViewComponent } from './campanha-lead-view.component';

@NgModule({
    imports: [
        SharedModule,
        CampanhaLeadFilterModule,
        LeadTableModule
    ],
    declarations: [
        CampanhaLeadViewComponent
    ],
    exports: [
        CampanhaLeadViewComponent
    ]
})
export class CampanhaLeadViewModule { }
